import { z } from 'zod';
import { requiredText } from './common';

/**
 * ENTRY    = o cliente deixou o equipamento na assistência (cópia da OS aberta; pode não ter peças/serviços ainda).
 * APPROVAL = o cliente aprovou as peças e serviços do orçamento.
 */
export const SIGNATURE_KINDS = ['ENTRY', 'APPROVAL'] as const;
export type SignatureKind = (typeof SIGNATURE_KINDS)[number];

export const SIGNATURE_KIND_LABELS: Record<SignatureKind, string> = {
  ENTRY: 'Entrada do equipamento',
  APPROVAL: 'Aprovação de peças e serviços',
};

/** Termo exibido ao cliente ao assinar (a aprovação usa o texto de autorização da empresa, se houver). */
export const SIGNATURE_DEFAULT_TEXTS: Record<SignatureKind, string> = {
  ENTRY:
    'Declaro que deixei na assistência técnica o equipamento descrito nesta ordem, com os acessórios e nas condições aqui informados, e que os dados conferem. Esta assinatura não aprova peças nem serviços.',
  APPROVAL: 'Li as informações acima e autorizo a execução das peças e serviços descritos nesta ordem, pelos valores informados.',
};

export const signatureKindSchema = z.enum(SIGNATURE_KINDS, { errorMap: () => ({ message: 'Tipo de assinatura inválido' }) });

/** Assinatura simples desenhada na tela (PNG em data URL). Sem validade jurídica — serve como aceite/recibo. */
export const signatureSubmitSchema = z.object({
  signerName: requiredText(120, 'Nome de quem assina', 2),
  image: z
    .string({ required_error: 'Desenhe a assinatura' })
    .max(900_000, 'Assinatura muito grande')
    .regex(/^data:image\/png;base64,[A-Za-z0-9+/]+=*$/, 'Assinatura inválida'),
  /** Só vale na bancada; no link público o tipo é o do link. */
  kind: signatureKindSchema.default('ENTRY'),
});
export type SignatureSubmitInput = z.infer<typeof signatureSubmitSchema>;

/** Validade padrão do link público de assinatura. */
export const SIGNATURE_LINK_DAYS = 7;
